/** New credits unlock this many runs per credit spent on a community analysis. */
export const COMMUNITY_RUNS_PER_CREDIT = 2500;

export const COMMUNITY_GRAPH_LABELS = {
    energy: "GJ/year",
    opEmissions: "GHG Emissions tCO₂",
    opCost: "$/year",
};

export const COMMUNITY_GRAPH_TOP_LABELS = {
    energy: "Energy Consumption Comparison",
    opEmissions: "GHG Emissions ",
    opCost: "Operating Costs",
};

export const COMMUNITY_GRAPH_LEGEND_LABELS = {
    energy: {
        top: [
            {
                colour: "#62BCF8",
                colourEC: "#083B37",
                label: "Electricity (kWh/year)",
                dataKey: "elecKWH",
                labelGJ: "Electricity (GJ/year)",
                dataKeyGJ: "elecGJ",
            },
            {
                colour: "#FFB22D",
                colourEC: "#E4E2D6",
                label: "Natural Gas (m³/year)",
                dataKey: "ngM3",
                labelGJ: "Natural Gas (GJ/year)",
                dataKeyGJ: "ngGJ",
            },
            {
                colour: "#18C1AD",
                colourEC: "#00E49E",
                label: "Total Energy without PV (GJ/year)",
                dataKey: "aecGJ",
            },
            {
                colour: "#E34D4D",
                // colourEC: "#F0E68C",
                colourEC: "#F8F9F4",
                label: "Total Energy with PV (GJ/year)",
                dataKey: "netGJ",
            },
        ],
        bottom: [
            {
                colour: "#fff",
                label: "GHG Emissions (tCO₂)",
                dataKey: "totalEmissionsTCO2",
            },
            {
                colour: "#fff",
                label: "Electricity Costs ($/year)",
                dataKey: "electricityCost",
            },
            {
                colour: "#fff",
                label: "Natural Gas Costs ($/year)",
                dataKey: "naturalGasCost",
            },
            // {
            //     colour: "#fff",
            //     label: "Water Costs ($/year)",
            // },
        ],
    },
    opEmissions: {
        top: [
            {
                colour: "#E6772B",
                colourEC: "#E8FCCF",
                label: "GHG Emissions (tCO₂)",
                dataKey: "totalEmissionsTCO2",
            },
        ],
        bottom: [
            {
                colour: "#fff",
                label: "Electricity (kWh/year)",
                dataKey: "elecKWH",
                labelGJ: "Electricity (GJ/year)",
                dataKeyGJ: "elecGJ",
            },
            {
                colour: "#fff",
                label: "Natural Gas (m³/year)",
                dataKey: "ngM3",
                labelGJ: "Natural Gas (GJ/year)",
                dataKeyGJ: "ngGJ",
            },
            {
                colour: "#fff",
                label: "Total Energy without PV (GJ/year)",
                dataKey: "aecGJ",
            },
            {
                colour: "#fff",
                label: "Total Energy with PV (GJ/year)",
                dataKey: "netGJ",
            },
            {
                colour: "#fff",
                label: "Electricity Costs ($/year)",
                dataKey: "electricityCost",
            },
            {
                colour: "#fff",
                label: "Natural Gas Costs ($/year)",
                dataKey: "naturalGasCost",
            },
            // {
            //     colour: "#fff",
            //     label: "Water Costs ($/year)",
            // },
        ],
    },
    opCost: {
        top: [
            {
                colour: "#62BCF8",
                colourEC: "#9FE870",
                label: "Electricity Costs ($/year)",
                dataKey: "electricityCost",
            },
            {
                colour: "#FFB22D",
                colourEC: "#F0E68C",
                label: "Natural Gas Costs ($/year)",
                dataKey: "naturalGasCost",
            },
            // {
            //     colour: "#18C1AD",
            //     label: "Water Costs ($/year)",
            // },
        ],
        bottom: [
            {
                colour: "#fff",
                label: "Electricity (kWh/year)",
                dataKey: "elecKWH",
                labelGJ: "Electricity (GJ/year)",
                dataKeyGJ: "elecGJ",
            },
            {
                colour: "#fff",
                label: "Natural Gas (m³/year)",
                dataKey: "ngM3",
                labelGJ: "Natural Gas (GJ/year)",
                dataKeyGJ: "ngGJ",
            },
            {
                colour: "#fff",
                label: "Total Energy without PV (GJ/year)",
                dataKey: "aecGJ",
            },
            {
                colour: "#fff",
                label: "Total Energy with PV (GJ/year)",
                dataKey: "netGJ",
            },
            {
                colour: "#fff",
                label: "GHG Emissions (tCO₂)",
                dataKey: "totalEmissionsTCO2",
            },
        ],
    },
};

export const COMMUNITY_GRAPH_TOP_COLOURS = {
    elecGJ: "#62BCF8",
    ngGJ: "#FFB22D",
    aecGJ: "#18C1AD",
    netGJ: "#E34D4D",
    totalEmissionsTCO2: "#E6772B",
    electricityCost: "#0049C6",
    naturalGasCost: "#F58020", // doesn't match label
};

export const COMMUNITY_GRAPH_TOP_COLOURS_ENVIRO_CENTRE = {
    elecGJ: "#083B37",
    ngGJ: "#E4E2D6",
    aecGJ: "#00E49E",
    netGJ: "#F8F9F4",
    totalEmissionsTCO2: "#E8FCCF",
    electricityCost: "#9FE870",
    naturalGasCost: "#F0E68C",
};

export const SORTED_UPGRADES_TYPES = [
    "ceilingWithAttic",
    "cathedral",
    "wall",
    "expFloor",
    "floorHeader",
    "basementWall",
    "basementSlab",
    "crawlspace",
    "slab",
    "window",
    "skylights",
    "door",
    "airTightness",
    "ventilation",
    "spaceHeating",
    "secondaryHeating",
    "spaceCooling",
    "primaryHotWater",
    "dwhr",
    "generation",
];

export const COMMUNITY_TABLE_HEADERS = {
    ceilingWithAttic: "Ceiling With Attic",
    cathedral: "Cathedral",
    wall: "Above Grade Walls / Garage wall",
    expFloor: "Exposed Floors",
    floorHeader: "Floor Header",
    basementWall: "Foundation Wall",
    basementSlab: "Basement Slab",
    crawlspace: "Crawlspace",
    slab: "Slab-on-grade",
    window: "Windows & Sliding Glass Doors",
    skylights: "Skylights",
    door: "Door",
    airTightness: "Air Tightness",
    ventilation: "Ventilation",
    heatingCooling: "Heating & Cooling",
    spaceHeating: "Space Heating",
    secondaryHeating: "Secondary Heating",
    spaceCooling: "Cooling & Heat Pumps",
    primaryHotWater: "Primary Hot Water",
    dwhr: "DWHR",
    generation: "Generation",
    // transportation: "Transportation",
    // baseLoads: "Base Loads",
};

/** Base model IDs highlighted in waterfall run-gap diagnostics (console + “Investigation focus” panel). */
export const WATERFALL_DIAGNOSTIC_FOCUS_BASE_MODEL_IDS = ["bXYqykqiRMnD4xJJvPMl"];

/** Single by-measure row probe (raw `runResultsByMeasure`, full strings) — set `upgradeId` to "" to disable. */
export const WATERFALL_DIAGNOSTIC_PROBE = {
    upgradeId: "upgrade-mouiwisz",
    upgradeType: "spaceCooling",
    requireSingleSegmentOnly: true,
};
